// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================================
   PLAYOUT LOGS – Enterprise Log Viewer
   Colors aligned with admin panel theme system:
     Light: body=#fff, text=#1d1f21, button=#139DF2, secondary=#f5f7fc
     Dark:  body=#1f222a, text=#fdfcfc, button=#4db8ff, secondary=#2d3038
     Status: green=#00c07b, warning=#ff2323
   =================================================== */

/* ── Stat Summary Cards ── */
.playout-stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
    margin-bottom: 20px;
}

.playout-stat-card {
    border-radius: 10px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: default;
    border: 1px solid transparent;
}

.playout-stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.playout-stat-icon {
    width: 46px;
    height: 46px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.playout-stat-icon.total {
    background: rgba(19, 157, 242, 0.12);
    color: #139DF2;
}

.playout-stat-icon.running {
    background: #d3ffd3;
    color: green;
}

.playout-stat-icon.completed {
    background: rgba(19, 157, 242, 0.12);
    color: #139DF2;
}

.playout-stat-icon.failed {
    background: #ffd9d9;
    color: #ff2323;
}

.playout-stat-icon.killed {
    background: #ffea008a;
    color: #000000;
}

.playout-stat-info h5 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
}

.playout-stat-info span {
    font-size: 12px;
    opacity: 0.65;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

/* ── Filter Toolbar ── */
.playout-filter-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    padding: 12px 14px;
    border-radius: 8px;
}

.playout-filter-bar .filter-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.playout-filter-bar .filter-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    opacity: 0.6;
    white-space: nowrap;
}

.playout-filter-bar select,
.playout-filter-bar input {
    height: 38px;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 13px;
    font-family: "Poppins";
    border: 1px solid #e5e5ea;
    outline: none;
    transition: border-color 0.2s ease;
}

.playout-filter-bar select:focus,
.playout-filter-bar input:focus {
    border-color: #139DF2;
    box-shadow: 0 0 0 2px rgba(19, 157, 242, 0.12);
}

.playout-filter-bar select {
    min-width: 140px;
    cursor: pointer;
}

.playout-filter-bar input[type="search"] {
    min-width: 220px;
}

.playout-filter-bar .filter-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
}

.playout-filter-bar .result-count {
    font-size: 12px;
    opacity: 0.5;
    font-weight: 500;
}

/* ── Status Badges ── */
.plog-status {
    display: inline-flex;
    align-items: center;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.3px;
    gap: 6px;
    white-space: nowrap;
    width: 120px;
    justify-content: center;
}

.plog-status .status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.plog-status.status-running {
    background: #d3ffd3;
    color: green;
}

.plog-status.status-running .status-dot {
    background: green;
    animation: statusPulse 1.5s ease-in-out infinite;
}

.plog-status.status-completed {
    background: rgb(34, 139, 34);
    color: #ffffff;
}

.plog-status.status-completed .status-dot {
    background: #ffffff;
}

.plog-status.status-failed {
    background: #ffd9d9;
    color: #ff2323;
}

.plog-status.status-failed .status-dot {
    background: #ff2323;
}

.plog-status.status-killed {
    background: #ffea008a;
    color: #000000;
}

.plog-status.status-killed .status-dot {
    background: #000000;
}

@keyframes statusPulse {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.4;
        transform: scale(0.7);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

/* ── Table Cell Helpers ── */
.plog-date-cell {
    line-height: 1.5;
}

.plog-date-cell .date-main {
    font-size: 13px;
    font-weight: 500;
}

.plog-date-cell .date-sub {
    font-size: 11px;
    opacity: 0.55;
}

.plog-stream-key {
    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 4px;
    background: rgba(108, 117, 125, 0.08);
    display: inline-block;
    word-break: break-all;
}

.plog-playout-name {
    font-weight: 600;
    font-size: 13px;
}

.plog-exit-code {
    font-family: 'SFMono-Regular', 'Consolas', monospace;
    font-size: 13px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 6px;
}

.plog-exit-code.exit-ok {
    background: #d3ffd3;
    color: green;
}

.plog-exit-code.exit-err {
    background: #ffd9d9;
    color: #ff2323;
}

/* ── View Button ── */
.plog-view-btn {
    padding: 5px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s ease;
    font-family: "Poppins";
}

.plog-view-btn:hover {
    opacity: 0.85;
}

/* ── Duration Bar ── */
.plog-duration-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 100px;
}

.plog-duration-text {
    font-size: 12px;
    font-weight: 600;
}

.plog-duration-bar {
    height: 4px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.plog-duration-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.5s ease;
}

.plog-duration-bar-fill.completed {
    background: linear-gradient(90deg, #139DF2, #4db8ff);
}

.plog-duration-bar-fill.failed {
    background: linear-gradient(90deg, #ff2323, #ff6b6b);
}

.plog-duration-bar-fill.running {
    background: linear-gradient(90deg, green, #00c07b);
}

.plog-duration-bar-fill.killed {
    background: linear-gradient(90deg, #cca000, #ffea00);
}


/* ===================================================
   SIDE DRAWER – Slide-in detail panel
   =================================================== */

/* Dark overlay behind the drawer */
.plog-drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1040;
    animation: overlayFadeIn 0.25s ease;
}

@keyframes overlayFadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* The drawer panel */
.plog-drawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 520px;
    max-width: 92vw;
    height: 100vh;
    z-index: 1050;
    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.15);
    animation: drawerSlideIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

@keyframes drawerSlideIn {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

.plog-drawer-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 0;
}

/* ── Drawer Header ── */
.plog-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5ea;
    position: static;
    top: 0;
    z-index: 2;
}

.plog-drawer-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.plog-drawer-header-left h5 {
    font-size: 16px;
    font-weight: 700;
}

.plog-drawer-close {
    background: transparent;
    border: none;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    flex-shrink: 0;
}

.plog-drawer-close:hover {
    background: rgba(0, 0, 0, 0.06);
}

/* ── Drawer Quick Summary ── */
.plog-drawer-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    border-bottom: 1px solid #e5e5ea;
}

.plog-drawer-summary-item {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-right: 1px solid #e5e5ea;
}

.plog-drawer-summary-item:last-child {
    border-right: none;
}

.plog-drawer-summary-label {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    opacity: 0.5;
}

.plog-drawer-summary-value {
    font-size: 16px;
    font-weight: 700;
}

/* ── Drawer Sections ── */
.plog-drawer-sections {
    padding: 8px 0;
}

.plog-drawer-section {
    padding: 16px 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.plog-drawer-section:last-child {
    border-bottom: none;
}

.plog-drawer-section-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    opacity: 0.45;
    margin-bottom: 12px;
}

.plog-drawer-section-title-error {
    color: #ff2323 !important;
    opacity: 1;
}

/* ── Key-Value Grid ── */
.plog-drawer-kv-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.plog-drawer-kv-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    gap: 16px;
}

.plog-drawer-kv-row:last-child {
    border-bottom: none;
}

.plog-drawer-kv-label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.55;
    white-space: nowrap;
    flex-shrink: 0;
}

.plog-drawer-kv-value {
    font-size: 13px;
    font-weight: 500;
    text-align: right;
    word-break: break-all;
}

.plog-drawer-kv-value.mono {
    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(108, 117, 125, 0.08);
}

/* ── Code Block ── */
.plog-drawer-code-block {
    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;
    font-size: 12px;
    padding: 12px 14px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.03);
    border: 1px solid #e5e5ea;
    word-break: break-all;
    white-space: pre-wrap;
    line-height: 1.6;
    max-height: 180px;
    overflow-y: auto;
}

/* ── Error Block ── */
.plog-drawer-error-block {
    border-radius: 8px;
    background: #ffd9d9;
    border: 1px solid rgba(255, 35, 35, 0.15);
    padding: 12px 14px;
}

.plog-drawer-error-type {
    font-size: 12px;
    font-weight: 700;
    color: #ff2323;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 4px;
}

.plog-drawer-error-message {
    font-size: 13px;
    color: #b91c1c;
    word-break: break-word;
    line-height: 1.5;
}


/* ── Responsive ── */
@media (max-width: 1200px) {
    .playout-stats-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .playout-stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .playout-filter-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .playout-filter-bar .filter-right {
        margin-left: 0;
    }

    .plog-drawer {
        width: 100vw;
        max-width: 100vw;
    }

    .plog-drawer-summary {
        grid-template-columns: 1fr;
    }

    .plog-drawer-summary-item {
        border-right: none;
        border-bottom: 1px solid #e5e5ea;
    }
}

@media (max-width: 480px) {
    .playout-stats-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Tv_Playout/PlayoutLogs.css"],"names":[],"mappings":"AAAA;;;;;;wDAMwD;;AAExD,6BAA6B;AAC7B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qDAAqD;IACrD,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,kCAAkC;AACtC;;AAEA;;IAEI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gDAAgD;AACpD;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,uEAAuE;IACvE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oDAAoD;IACpD,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,oDAAoD;AACxD;;;AAGA;;wDAEwD;;AAExD,mCAAmC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,aAAa;IACb,2CAA2C;IAC3C,kEAAkE;IAClE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,UAAU;AACd;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,qCAAqC;IACrC,MAAM;IACN,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,cAAc;IACd,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,uEAAuE;IACvE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA,qBAAqB;AACrB;IACI,uEAAuE;IACvE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA,qBAAqB;AACrB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* ===================================================\n   PLAYOUT LOGS – Enterprise Log Viewer\n   Colors aligned with admin panel theme system:\n     Light: body=#fff, text=#1d1f21, button=#139DF2, secondary=#f5f7fc\n     Dark:  body=#1f222a, text=#fdfcfc, button=#4db8ff, secondary=#2d3038\n     Status: green=#00c07b, warning=#ff2323\n   =================================================== */\n\n/* ── Stat Summary Cards ── */\n.playout-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 14px;\n    margin-bottom: 20px;\n}\n\n.playout-stat-card {\n    border-radius: 10px;\n    padding: 16px 18px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    cursor: default;\n    border: 1px solid transparent;\n}\n\n.playout-stat-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.playout-stat-icon {\n    width: 46px;\n    height: 46px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    flex-shrink: 0;\n}\n\n.playout-stat-icon.total {\n    background: rgba(19, 157, 242, 0.12);\n    color: #139DF2;\n}\n\n.playout-stat-icon.running {\n    background: #d3ffd3;\n    color: green;\n}\n\n.playout-stat-icon.completed {\n    background: rgba(19, 157, 242, 0.12);\n    color: #139DF2;\n}\n\n.playout-stat-icon.failed {\n    background: #ffd9d9;\n    color: #ff2323;\n}\n\n.playout-stat-icon.killed {\n    background: #ffea008a;\n    color: #000000;\n}\n\n.playout-stat-info h5 {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.playout-stat-info span {\n    font-size: 12px;\n    opacity: 0.65;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n/* ── Filter Toolbar ── */\n.playout-filter-bar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n    padding: 12px 14px;\n    border-radius: 8px;\n}\n\n.playout-filter-bar .filter-group {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.playout-filter-bar .filter-label {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    opacity: 0.6;\n    white-space: nowrap;\n}\n\n.playout-filter-bar select,\n.playout-filter-bar input {\n    height: 38px;\n    padding: 0 12px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: \"Poppins\";\n    border: 1px solid #e5e5ea;\n    outline: none;\n    transition: border-color 0.2s ease;\n}\n\n.playout-filter-bar select:focus,\n.playout-filter-bar input:focus {\n    border-color: #139DF2;\n    box-shadow: 0 0 0 2px rgba(19, 157, 242, 0.12);\n}\n\n.playout-filter-bar select {\n    min-width: 140px;\n    cursor: pointer;\n}\n\n.playout-filter-bar input[type=\"search\"] {\n    min-width: 220px;\n}\n\n.playout-filter-bar .filter-right {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.playout-filter-bar .result-count {\n    font-size: 12px;\n    opacity: 0.5;\n    font-weight: 500;\n}\n\n/* ── Status Badges ── */\n.plog-status {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 14px;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: capitalize;\n    letter-spacing: 0.3px;\n    gap: 6px;\n    white-space: nowrap;\n    width: 120px;\n    justify-content: center;\n}\n\n.plog-status .status-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.plog-status.status-running {\n    background: #d3ffd3;\n    color: green;\n}\n\n.plog-status.status-running .status-dot {\n    background: green;\n    animation: statusPulse 1.5s ease-in-out infinite;\n}\n\n.plog-status.status-completed {\n    background: rgb(34, 139, 34);\n    color: #ffffff;\n}\n\n.plog-status.status-completed .status-dot {\n    background: #ffffff;\n}\n\n.plog-status.status-failed {\n    background: #ffd9d9;\n    color: #ff2323;\n}\n\n.plog-status.status-failed .status-dot {\n    background: #ff2323;\n}\n\n.plog-status.status-killed {\n    background: #ffea008a;\n    color: #000000;\n}\n\n.plog-status.status-killed .status-dot {\n    background: #000000;\n}\n\n@keyframes statusPulse {\n    0% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.4;\n        transform: scale(0.7);\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* ── Table Cell Helpers ── */\n.plog-date-cell {\n    line-height: 1.5;\n}\n\n.plog-date-cell .date-main {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.plog-date-cell .date-sub {\n    font-size: 11px;\n    opacity: 0.55;\n}\n\n.plog-stream-key {\n    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;\n    font-size: 12px;\n    padding: 3px 10px;\n    border-radius: 4px;\n    background: rgba(108, 117, 125, 0.08);\n    display: inline-block;\n    word-break: break-all;\n}\n\n.plog-playout-name {\n    font-weight: 600;\n    font-size: 13px;\n}\n\n.plog-exit-code {\n    font-family: 'SFMono-Regular', 'Consolas', monospace;\n    font-size: 13px;\n    font-weight: 700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 6px;\n}\n\n.plog-exit-code.exit-ok {\n    background: #d3ffd3;\n    color: green;\n}\n\n.plog-exit-code.exit-err {\n    background: #ffd9d9;\n    color: #ff2323;\n}\n\n/* ── View Button ── */\n.plog-view-btn {\n    padding: 5px;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    font-family: \"Poppins\";\n}\n\n.plog-view-btn:hover {\n    opacity: 0.85;\n}\n\n/* ── Duration Bar ── */\n.plog-duration-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 100px;\n}\n\n.plog-duration-text {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.plog-duration-bar {\n    height: 4px;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.06);\n    overflow: hidden;\n}\n\n.plog-duration-bar-fill {\n    height: 100%;\n    border-radius: 4px;\n    transition: width 0.5s ease;\n}\n\n.plog-duration-bar-fill.completed {\n    background: linear-gradient(90deg, #139DF2, #4db8ff);\n}\n\n.plog-duration-bar-fill.failed {\n    background: linear-gradient(90deg, #ff2323, #ff6b6b);\n}\n\n.plog-duration-bar-fill.running {\n    background: linear-gradient(90deg, green, #00c07b);\n}\n\n.plog-duration-bar-fill.killed {\n    background: linear-gradient(90deg, #cca000, #ffea00);\n}\n\n\n/* ===================================================\n   SIDE DRAWER – Slide-in detail panel\n   =================================================== */\n\n/* Dark overlay behind the drawer */\n.plog-drawer-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.35);\n    z-index: 1040;\n    animation: overlayFadeIn 0.25s ease;\n}\n\n@keyframes overlayFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* The drawer panel */\n.plog-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 520px;\n    max-width: 92vw;\n    height: 100vh;\n    z-index: 1050;\n    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.15);\n    animation: drawerSlideIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n@keyframes drawerSlideIn {\n    from {\n        transform: translateX(100%);\n    }\n\n    to {\n        transform: translateX(0);\n    }\n}\n\n.plog-drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n}\n\n/* ── Drawer Header ── */\n.plog-drawer-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e5e5ea;\n    position: static;\n    top: 0;\n    z-index: 2;\n}\n\n.plog-drawer-header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.plog-drawer-header-left h5 {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.plog-drawer-close {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n    flex-shrink: 0;\n}\n\n.plog-drawer-close:hover {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n/* ── Drawer Quick Summary ── */\n.plog-drawer-summary {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0;\n    border-bottom: 1px solid #e5e5ea;\n}\n\n.plog-drawer-summary-item {\n    padding: 16px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    border-right: 1px solid #e5e5ea;\n}\n\n.plog-drawer-summary-item:last-child {\n    border-right: none;\n}\n\n.plog-drawer-summary-label {\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    opacity: 0.5;\n}\n\n.plog-drawer-summary-value {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n/* ── Drawer Sections ── */\n.plog-drawer-sections {\n    padding: 8px 0;\n}\n\n.plog-drawer-section {\n    padding: 16px 24px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.plog-drawer-section:last-child {\n    border-bottom: none;\n}\n\n.plog-drawer-section-title {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.7px;\n    opacity: 0.45;\n    margin-bottom: 12px;\n}\n\n.plog-drawer-section-title-error {\n    color: #ff2323 !important;\n    opacity: 1;\n}\n\n/* ── Key-Value Grid ── */\n.plog-drawer-kv-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.plog-drawer-kv-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n    gap: 16px;\n}\n\n.plog-drawer-kv-row:last-child {\n    border-bottom: none;\n}\n\n.plog-drawer-kv-label {\n    font-size: 12px;\n    font-weight: 600;\n    opacity: 0.55;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.plog-drawer-kv-value {\n    font-size: 13px;\n    font-weight: 500;\n    text-align: right;\n    word-break: break-all;\n}\n\n.plog-drawer-kv-value.mono {\n    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;\n    font-size: 12px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: rgba(108, 117, 125, 0.08);\n}\n\n/* ── Code Block ── */\n.plog-drawer-code-block {\n    font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;\n    font-size: 12px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.03);\n    border: 1px solid #e5e5ea;\n    word-break: break-all;\n    white-space: pre-wrap;\n    line-height: 1.6;\n    max-height: 180px;\n    overflow-y: auto;\n}\n\n/* ── Error Block ── */\n.plog-drawer-error-block {\n    border-radius: 8px;\n    background: #ffd9d9;\n    border: 1px solid rgba(255, 35, 35, 0.15);\n    padding: 12px 14px;\n}\n\n.plog-drawer-error-type {\n    font-size: 12px;\n    font-weight: 700;\n    color: #ff2323;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    margin-bottom: 4px;\n}\n\n.plog-drawer-error-message {\n    font-size: 13px;\n    color: #b91c1c;\n    word-break: break-word;\n    line-height: 1.5;\n}\n\n\n/* ── Responsive ── */\n@media (max-width: 1200px) {\n    .playout-stats-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .playout-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .playout-filter-bar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .playout-filter-bar .filter-right {\n        margin-left: 0;\n    }\n\n    .plog-drawer {\n        width: 100vw;\n        max-width: 100vw;\n    }\n\n    .plog-drawer-summary {\n        grid-template-columns: 1fr;\n    }\n\n    .plog-drawer-summary-item {\n        border-right: none;\n        border-bottom: 1px solid #e5e5ea;\n    }\n}\n\n@media (max-width: 480px) {\n    .playout-stats-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
